<template>
    <div class="container">
        <ProductsMenu @productsSelect="productsSelect"/>
        <div>
            <div class="introduction">
                <div class="introductionTitle">
                    <h1 data-aos="fade-up">BioMonitor生物资源运输监控管理平台</h1>
                    <div data-aos="fade-up"></div>
                    <div data-aos="fade-up"BioMonitor生物资源运输监控管理平台可对生物样本运输过程进行全程监控，包括运输过程中样本的物理位置、容器内湿度温度、并生成转运质控单，可对样本运输过程中出现的异常情况及时做出警报，保证完整的质控流程。</div>
                </div>
                <div data-aos="zoom-in">
                    <div></div>
                    <img :src="require('@/assets/img/products/transport/transportTitle.png')" alt="">
                    <div></div>
                </div>
            </div>
            <div class="TRANSPORTATION">
                <div data-aos="fade-up">TRANSPORTATION</div>
                <div data-aos="fade-up">MONITORING</div>
                <div data-aos="fade-up">运输状态全监控</div>
                <div data-aos="fade-up">数据无死角</div>
                <div>
                    <div data-aos="zoom-in">
                        <img :src="require('@/assets/img/products/transport/TRANSPORTATIONBottom.png')" alt="">
                    </div>
                </div>
                <div data-aos="fade-left">《《《<span style="display: inline-block;width: 35px"></span>《《《</div>
            </div>
            <div class="guarantee">
                <div class="title" data-aos="fade-up">样本资源保障</div>
                <div class="content">
                    <div v-for="item in guarantee">
                        <img :src="item.img" alt="" data-aos="zoom-in">
                        <div data-aos="fade-up">
                            <div>{{item.title}}</div>
                            <div>{{item.content}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sysShow">
                <div class="title" data-aos="fade-up">系统展示</div>
                <div>
                    <img v-for="item,index in sysShow" :src="item" alt="" :data-aos="index%2===0?'fade-right':'fade-left'">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProductsMenu from "../../components/ProductsMenu";
export default {
    name:'Share',
    components: {ProductsMenu},
    data(){
      return {
        guarantee:[
            {
                img:require('@/assets/img/products/transport/guarantee1.png'),
                title:'冷链运输，全方位护航',
                content:'从采集地到存储地运输全过程采用标准冷链运输，实现供体源信息和生物资源数据无误差对接'
            },
            {
                img:require('@/assets/img/products/transport/guarantee2.png'),
                title:'数据监测，多维度警报',
                content:'温度、湿度、气压、电压数据按设定时间间隔上传，定时监控采用多维度警报、更全面、更及时，改善传统的单一报警模式运输箱保证三防两晒，防止生物污染'
            },
            {
                img:require('@/assets/img/products/transport/guarantee3.png'),
                title:'源体安全，数据流管理',
                content:'全数据流管理，打造数据流闭环生态系统，定时必达，管理数字化生命：定时达线路的每个中转以及交接环节都经过反复梳理，无缝对接，确保生物资源安全、稳定的送达；管理数字化生命，针对供体数据和生物资源数据的存储'
            },
        ],
        sysShow:[
          require('@/assets/img/products/transport/sysShow1.png'),
          require('@/assets/img/products/transport/sysShow2.png'),
          require('@/assets/img/products/transport/sysShow3.png'),
          require('@/assets/img/products/transport/sysShow4.png'),
        ]
      }
    },
    methods:{
        productsSelect(src){
	        this.$emit('productsSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .introduction{
        width: 1045px;
        margin: 213px auto 0;
        display: flex;
        justify-content: space-between;
        .introductionTitle{
            font-family: SourceHanSansCN-Normal;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 25px;
            letter-spacing: 1px;
            padding-top: 100px;
            h1{
                font-size: 19px;
            }
            &>div:nth-child(2){
                width: 65px;
                height: 2px;
                background: #006efd;
                margin: 13px 0 50px 0px;
            }
            &>div:nth-child(3){
                font-size: 14px;
                letter-spacing: 1px;
                text-indent: 2em;
            }
        }
        &>div:nth-child(2){
            width: 490px;
            height: 352px;
            margin-left: 59px;
            position: relative;
            padding-left: 34px;
            div:nth-child(1){
                position: absolute;
                bottom: 0;
                left: 0;
                width: 456px;
                height: 328px;
                background: linear-gradient(45deg, #ededed 0, #fff 25%, transparent 25%, transparent 50%, #ededed 50%, #fff 75%, transparent 75%, transparent 100%);
                background-size: 10px 10px;
            }
            img{
                position: relative;
            }
            div:nth-child(3){
                width: 17px;
                height: 55px;
                position: absolute;
                left: 90px;
                bottom: 11px;
                background: #006efd;
            }
        }
    }
    .TRANSPORTATION{
        width: 100%;
        height: 900px;
        background: url("../../assets/img/products/transport/TRANSPORTATION.png");
        margin-top: 134px;
        padding-left: 430px;
        padding-top: 164px;
        box-sizing: border-box;
        &>div:nth-child(1){
            height: 52px;
            font-family: VerdanaPro-Bold;
            font-size: 68px;
            font-weight: bold;
            font-stretch: normal;
            line-height: 47px;
            letter-spacing: 0px;
            color: #ffffff;
        }
        div:nth-child(2){
            height: 52px;
            font-family: VerdanaPro-Light;
            font-size: 68px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 47px;
            letter-spacing: 0px;
            color: #ffffff;
            margin-top: 21px;
        }
        div:nth-child(3){
            margin-top: 120px
        }
        div:nth-child(4){
            margin-top: 11px
        }
        div:nth-child(3),div:nth-child(4){
            height: 42px;
            font-family: SourceHanSansCN-Normal;
            font-size: 45px;
            font-stretch: normal;
            line-height: 47px;
            letter-spacing: 4px;
            color: #ffffff;
        }
        div:nth-child(5){
            width: 1034px;
            display: flex;
            justify-content: flex-end;
            margin-top: -22px;
            div{
                width: 360px;
                height: 330px;
                box-sizing: border-box;
                padding: 33px 42px;
                background: #fff;
            }
        }
        div:nth-child(6){
            width: 1034px;
            display: flex;
            justify-content: flex-end;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 47px;
            letter-spacing: 2px;
            margin-top: 13px;
            color: #fff;
        }
    }
    .guarantee{
        width: 1170px;
        margin: 100px auto 0;
        .title{
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 25px;
            letter-spacing: 2px;
            width: 158px;
            height: 25px;
            margin: 0 auto 105px;
            background-color: #006efd;
            text-align: center;
            color: #fff;
        }
        .content{
            display: flex;
            justify-content: space-between;
            &>div{
                img{
                    border-radius: 5px;
                }
                &>div{
                    width: 300px;
                    height: 206px;
                    margin: -50px auto 0;
                    box-shadow: 0 0 10px #dedede;
                    border-radius: 5px;
                    background: #fff;
                    position: relative;
                    padding:15px 28px;
                    box-sizing: border-box;
                    div:nth-child(1){
                        font-size: 20px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 2px;
                    }
                    div:nth-child(2){
                        font-size: 15px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 1px;
                        margin-top: 14px;
                    }
                }
            }
            &>div:nth-child(3)>div{
                padding: 20px;
            }
        }
    }
    .sysShow{
        width: 1153px;
        margin: 100px auto;
        .title{
            width: 115px;
            height: 25px;
            background-color: #006efd;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 25px;
            letter-spacing: 2px;
            color: #ffffff;
            text-align: center;
            margin: 0 auto;
        }
        &>div:nth-child(2){
            width: 100%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-top: 40px;
            padding-top: 50px;
            img{
                margin-top: 40px;
            }
        }
    }
</style>
